import store from '@/store';
import router from '@/router';
import jwtDecode from 'jwt-decode';
import { ILog, IUserActivityLog } from '@/definitions/log';
import { LogLevel, LogType, ActionType } from '@/utils/logTypes';
import { endpoints } from '@/endpoints/endpoints';

const env = {
  isEnabled: null as boolean | null,
  isConlose: null as boolean | null,
  canBeExecute(): boolean {
    if (this.isEnabled === null) {
      const isEnabled: string = process.env.VUE_APP_LOGGING_ENABLED;
      this.isEnabled = isEnabled === 'true';
    }
    return this.isEnabled;
  },
  IsConlose(): boolean {
    if (this.isConlose === null) {
      const isConlose: string = process.env.VUE_APP_LOGGING_CONLOSE;
      this.isConlose = isConlose === 'true';
    }
    return this.isConlose;
  },
};

const logger = {
  sendToConsoles(level: LogLevel, log: ILog, action: ActionType): void {
    const msg = `${ActionType[action]}, ${log.type},${log.level}`;
    switch (level) {
      case LogLevel.TRACE:
        console.trace(msg, log);
        break;
      case LogLevel.DEBUG:
        console.debug(msg, log);
        break;
      case LogLevel.INFO:
        console.info(msg, log);
        break;
      case LogLevel.WARN:
        console.warn(msg, log);
        break;
      case LogLevel.ERROR:
      case LogLevel.FATAL:
        console.error(msg, log);
        break;
      default:
        console.log(msg, log);
        break;
    }
  },
  sendToAnalytics(level: LogLevel, log: ILog, action: ActionType): void {
    const { id, impersonatorId } = log.user as any;
    const { id: sessionId } = log.session as any;
    const payload = {
      sessionId,
      payload: JSON.stringify(log),
      userId: id,
      impersonatorId,
      action,
      level,
    } as IUserActivityLog;

    const blob = new Blob([JSON.stringify(payload)], {
      type: 'application/json',
    });

    fetch(endpoints.userActivityLog, {
      body: blob,
      method: 'POST',
      keepalive: true,
    });
  },
};

const LogFactory = {
  getLogFormatData(level: LogLevel, type: LogType, data: object): ILog {
    const token = store?.state?.account?.token ?? '';
    const session: any = {};
    const user: any = {};
    if (token !== null && token !== undefined && token !== '') {
      const tokenDecode: any = jwtDecode(token);
      // session
      session.id = tokenDecode.sessionId;
      // user
      user.role = tokenDecode.role;
      user.id = tokenDecode.nameid;
      user.accountNo = tokenDecode.accountNo;
      user.email = tokenDecode.email;
      user.company = tokenDecode.company;
      user.impersonatorId = tokenDecode.cphqUser ?? tokenDecode.impersonator;
    }
    const tempData = {
      timestamp: new Date().toISOString(),
      level: LogLevel[level],
      type: LogType[type],
      page: {
        name: router.currentRoute.name,
        params: router.currentRoute.params,
        query: router.currentRoute.query,
      },
      user,
      session,
      ...data,
    } as ILog;
    return tempData;
  },
  log(level: LogLevel, log: ILog, action: ActionType) {
    const hasSessionId = () => {
      const { id: sessionId } = log.session as any;
      return sessionId !== null && sessionId !== undefined && sessionId !== '';
    };

    if (env.canBeExecute() && hasSessionId()) {
      if (env.IsConlose() === true) {
        logger.sendToConsoles(level, log, action);
      } else {
        logger.sendToAnalytics(level, log, action);
      }
    }
  },
};

export { LogFactory };
